import React from 'react';
import { Text } from '@cuemath/comps';
import { Button, Separator } from '@cuemath/web-comps';
import { Head } from 'modules/form';
import styled from 'styled-components';
import ThumbsUp from 'img/thumbs-up.svg';
import ThumbsDown from 'img/thumbs-down.svg';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from 'actions/modal';
import { useMappingLogPatch } from 'actions/auto-mapping';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 90%;
`;

const MappingRatingModal = ({ actions, invalidateLogs, data: { mappingLogId } }) => {
  const onMappingLogUpdate = () => {
    invalidateLogs();
    actions.closeModal();
  };
  const { patch: updateMappingRating, isProcessing } = useMappingLogPatch({
    onComplete: onMappingLogUpdate,
  });
  const onMappingRatingClick = rating => {
    if (!isProcessing) {
      updateMappingRating(mappingLogId, { is_mapping_good: rating });
    }
  };

  return (
    <Container>
      <Head>
        <Text size="xlarge" align="center">
          Please Rate the Mapping
        </Text>
      </Head>
      <Separator transparent height="20" />
      <ButtonContainer>
        <Button
          size="small"
          label="Good"
          width="140px"
          backgroundColor="transparent"
          iconConfig={{ imgLink: ThumbsUp }}
          onClick={() => onMappingRatingClick(true)}
        ></Button>
        <Button
          size="small"
          label="Bad"
          width="140px"
          backgroundColor="transparent"
          iconConfig={{ imgLink: ThumbsDown }}
          onClick={() => onMappingRatingClick(false)}
        ></Button>
      </ButtonContainer>
    </Container>
  );
};
MappingRatingModal.propTypes = {
  data: PropTypes.shape({
    mappingLogId: PropTypes.string.isRequired,
  }),
  invalidateLogs: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    closeModal: PropTypes.func.isRequired,
  }),
};
export default connect(null, dispatch => ({
  actions: bindActionCreators(
    {
      closeModal,
    },
    dispatch,
  ),
}))(MappingRatingModal);
